<template>
  <section style="position:relative" id="section">
		
		<el-row class="statusRowWhite">
			<div class="RowChild">
			<el-button  size="medium" icon="el-icon-arrow-left" type="primary"  @click="$router.go(-1)">返回</el-button>
    	</div>
    	<div class="RowChild">
			公司名称：
			<el-select v-model="pdata.cp_company_id" filterable  clearable    placeholder="请选择公司名称"  @change='getList'>
		    <el-option
		      v-for="item in companyList"
		      :key="item.id"
		      :label="item.name"
		      :value="item.id">
		    </el-option>
			</el-select>
    	</div>
    	<div class="RowChild">
      &nbsp;结算期：
	    <el-date-picker
      v-model="d_date"
      type="monthrange"
      format="yyyyMM"
	    value-format="yyyyMM"
	    @change='getList'
      start-placeholder="开始月份"
      end-placeholder="结束月份"
      >
    </el-date-picker>
    </div>
    <div class="RowChild">
    	&nbsp;分成方式：  &nbsp;
		 <el-select class="xs24" v-model="pdata.bill_type" placeholder="请选择账单类型"   @change='getList'>
		 	  <el-option key="0" label="汇总" value="0"></el-option>			
		    <el-option key="1" label="原生分成账单" value="1"></el-option>					  
		    <el-option key="2" label="利润分成账单" value="2"></el-option>
			</el-select>
		</div>

 		<div class="RowChild">
    	<el-button size="medium" icon="el-icon-download" type="primary" @click="getBillList">导出预览</el-button>
    </div>
    	

     
		 
    </el-row>
    
    <el-row  style="padding:15px;background:#fff">

	    <!--列表-->
	    <el-table
	      :data="plist"
	      style="width: 100%;"
	      stripe
	      row-key="id"

	      class="demo-table"
	      show-summary
	      :summary-method="getSummaries" 
	    >

	    <!-- <el-table-column type="selection" min-width="30px"></el-table-column>-->
	    
	     <el-table-column prop="date"  label="结算周期" min-width="140px" align="center" >
			    <template slot-scope="scope">
									{{scope.row.sdate}}~{{scope.row.edate}}
			    </template>
	     </el-table-column>
	     <el-table-column prop="date"  label="结算方式" min-width="140px" align="center" >
			    <template slot-scope="scope">
			    		<span v-if="scope.row.bill_type==1">
			    			原生分成
			    		</span>
			    		<span v-if="scope.row.bill_type==2">
			    			利润分成
			    		</span>
			    </template>
	     </el-table-column>
	     
	     <el-table-column prop="total_cost"  label="结算金额"  align="center">
	     		<template slot-scope="scope">
									￥{{scope.row.total_cost}}
			    </template>
	     </el-table-column>
	     <el-table-column prop="status"  label="操作" min-width="50px" width="400"  align="center">
	     		 <template slot-scope="scope">
							<el-button size="mini" type="primary"  @click="$router.push('/billCpData/index?cp_company_id='+pdata.cp_company_id+'&bill_type='+scope.row.bill_type+'&d_date='+scope.row.sdate.substring(0,6))">账单明细</el-button>
	     		 </template>
	     </el-table-column>
	     
	    
	    </el-table>
    
    </el-row>

    

   
     <el-dialog
      title="分成账单统计"
      :visible.sync="billDialog"
      width="900px"
      custom-class="dialog"
      :close-on-click-modal="false"
      center
    >
      <el-form >
      	
				    <div  class="el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition" style="width: 900px;">
							<div class="el-table__header-wrapper">
								<table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 900px;" id="ta"  >
									<colgroup >
										<col name="el-table_3_column_28_column_29" width="33%">
										<col name="el-table_3_column_28_column_30" width="33%"  >
										<col name="el-table_3_column_28_column_31" width="33%" >
									</colgroup>
									<thead class="is-group has-gutter">
										<tr class="">
												<td colspan="3" rowspan="1" class="el-table_3_column_28  is-center  ">
													<div class="cell" v-if="pdata.bill_type==0">{{companyName}}汇总分成统计</div>
													<div class="cell" v-if="pdata.bill_type==1">{{companyName}}原生分成统计</div>
													<div class="cell" v-if="pdata.bill_type==2">{{companyName}}利润分成统计</div>
												</td>
										</tr>
										<tr class="">
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_29  is-center   is-leaf">
												<div class="cell">结算周期</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_30  is-center   is-leaf">
												<div class="cell">分成方式</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_31  is-center   is-leaf">
												<div class="cell">结算金额</div>
											</th>
										</tr>
									</thead>
									<tbody class="el-table__body">
										<tr class="el-table__row" :class="index%2==1?'el-table__row--striped':''" v-for="item,index in billList" >
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_29 is-center ">
												<div class="cell"><span >{{item.sdate}}~{{item.edate}}</span></div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_30 is-center ">
												<div class="cell" v-if="item.bill_type==1">原生分成</div>
												<div class="cell" v-if="item.bill_type==2">利润分成</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_31 is-center ">
												<div class="cell">￥{{item.total_cost}}</div>
											</td>
									</tr>
										<tr >
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_29 is-center ">
												合计
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_30 is-center ">
												-
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_31 is-center ">
												￥{{total.total_cost}}
											</td>
										</tr>
										<!---->
									</tbody>
								</table>
							</div>
						</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tableToExcel" >导出Excel</el-button>
        <el-button @click="handleDown" >导出pdf</el-button>
        <el-button @click="billDialog = false">取消</el-button>
      </div>
    </el-dialog>
    


 
    
  
    
    
    
    
  </section>
</template>

<script>
import htmlToPdf from '../../vendor/htmlToPdf'
import $ from "jquery";
import { getbillCpDatasummaryDetail ,getCPCompanyList } from "../../api/api";
//import UploadImg from "./uploadImg.vue";
import { mapGetters } from 'vuex';
export default {
  components: {
//  UploadImg
  },
  data() {
    return {
     
      pdata: {
        cp_company_id:"",
				bill_type:'0', 
				sdate:(new Date().getMonth()+1)<10?new Date().getFullYear().toString()+'0'+(new Date().getMonth()+1):new Date().getFullYear().toString()+(new Date().getMonth()+1).toString(),
				edate:(new Date().getMonth()+1)<10?new Date().getFullYear().toString()+'0'+(new Date().getMonth()+1):new Date().getFullYear().toString()+(new Date().getMonth()+1).toString(),
      },
      d_date:[(new Date().getMonth()+1)<10?new Date().getFullYear().toString()+'0'+(new Date().getMonth()+1):new Date().getFullYear().toString()+(new Date().getMonth()+1).toString(),(new Date().getMonth()+1)<10?new Date().getFullYear().toString()+'0'+(new Date().getMonth()+1):new Date().getFullYear().toString()+(new Date().getMonth()+1).toString()],
      plist: [],
      companyName:'',
      billList:[],
      companyList:[],
    
     
      prWidth: 0,
     
			billDialog:false,
			height:710,
			
      total:{
      	total_cost:0,
      },
     
    };
  },
  watch: {
  	
    "pdata.cp_company_id": {
    	handler(n, o) {
      	this.getList();
    	},
      deep: true
    },

  },
  methods: {
  
  	handleDown () {
  		 var billname;
				if(this.pdata.bill_type==1){
					billname = '原生分成'
				}
				else if(this.pdata.bill_type==2){
					billname = '利润分成'
				}
				if(this.pdata.bill_type==0){
					billname = '汇总分成'
				}
        htmlToPdf.downloadPDF(document.querySelector('#ta'),  this.companyName+this.pdata.sdate+"~"+this.pdata.edate+ billname+"分成统计")
    },
  	getSummaries(param) {
		    const { columns, data } = param;
		    const sums = [];
		    columns.forEach((column, index) => {
		      if (index === 0) {
		        sums[index] = '合计';
		        return;
		      }
	      	if(index === 1||index===3||index===4){
	      	 		 sums[index] = '-';
	      	 			return;
	      	}
	      
	     
		      const values = data.map(item => Number(item[column.property]));
		      if (!values.every(value => isNaN(value))) {
		        sums[index] = values.reduce((prev, curr) => {
		          const value = Number(curr);
		          if (!isNaN(value)) {
		            return prev + curr;
		          } else {
		            return prev;
		          }
		        }, 0);
		        sums[index] ='￥'+ sums[index].toFixed(2)  ;
		      } else {
		        sums[index] = '-';
		      }
		    });
		
		    return sums;
		},
  	search() {
      this.getList();
   },
  	createBillData(){
  		 this.editDialog = true;
  	},
  	
  	
  	
  
  	
    getList() {
      var p = "";
      this.pdata.sdate = this.d_date[0];
      this.pdata.edate = this.d_date[1];
     
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getbillCpDatasummaryDetail(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data.list&&res.data.list.length>0){
        		this.plist = res.data.list;
            this.maxPage = res.data.max_page;
	        	this.total={
					      	total_cost:0,
					    }
	        	this.plist.forEach((v,i) => {
	        		 this.total.total_cost += v.total_cost - 0;
	        	})
	        	this.total.total_cost = this.total.total_cost.toFixed(2)
          }  
        	else{
        		this.plist = [];
            this.maxPage =1;
        	}
          
        }
      });
      getCPCompanyList('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data&&res.data.list.length>0){
        		this.companyList = res.data.list;
        		this.companyList.forEach((v,i)=>{
			      	if(v.id==this.pdata.cp_company_id){
			      		this.companyName= v.name;
			      	}
			      })
        	}
          
        }
      });
     
    },
    getBillList(status,company_id,id) {
    	this.billDialog=true;
    	this.company=this.company_a;
    	this.wecompany=this.company_b;
    	this.billList =this.plist;
    },
   
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    search() {
      // this.$refs.input.blur();
      this.getList();
    },
   
    base64(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
    },
    //替换table数据和worksheet名字
    format (s, c) {
        return s.replace(/{(\w+)}/g,
            function (m, p) {
                return c[p];
            });
    },
    tableToExcel() {
        var uri = 'data:application/vnd.ms-excel;base64,';
        var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"' +
            'xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>'
            + '<x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets>'
            + '</x:ExcelWorkbook></xml><![endif]-->' +
            ' <style type="text/css">' +
            'table td {' +
   
            'width: auto;' +
            'height: 30px;' +
            ' text-align: center;' +
            'background-color: #ffffff;' +
            'color: #000000;' +
            ' }' +
            'table th {' +
    
            'width: auto;' +
            'height: 30px;' +
            ' text-align: center;' +
            'background-color: #ffffff;' +
            'color: #000000;' +
            ' }' +
            '</style>' +
            '</head><body ><table class="excelTable" border="1" cellspacing="1" cellpadding="1">{table}</table></body></html>';
            var tableid = document.getElementById('ta');
            var billname;
           if(this.pdata.bill_type==1){
							billname = '原生分成'
						}
						else if(this.pdata.bill_type==2){
							billname = '利润分成'
						}
						if(this.pdata.bill_type==0){
							billname = '汇总分成'
						}
            var ctx = {worksheet: this.companyName+billname+"账单统计" || 'Worksheet', table: tableid.innerHTML};
        		console.log(uri + this.base64(this.format(template, ctx)));
	        	//	location.href = uri + this.base64(this.format(template, ctx));
	        	this.base64ToFile(uri + this.base64(this.format(template, ctx)))
    },
    base64ToFile(base) {
    	 var billname;
				if(this.pdata.bill_type==1){
					billname = '原生分成'
				}
				else if(this.pdata.bill_type==2){
					billname = '利润分成'
				}
				if(this.pdata.bill_type==0){
					billname = '汇总分成'
				}
      const arr = base.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      if (window.navigator.msSaveBlob) {
        // for ie 10 and later
        try {
          const blobObject = new Blob([u8arr], { type: mime });
          window.navigator.msSaveBlob(blobObject,  this.companyName+this.pdata.sdate+"~"+this.pdata.edate+billname+'账单统计.xls');
        } catch (e) {
          console.log(e);
        }
      } else {
        const url = window.URL.createObjectURL(new Blob([u8arr], { type: mime }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.companyName+this.pdata.sdate+"~"+this.pdata.edate+billname+'账单统计.xls');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 下载完成移除元素
        window.URL.revokeObjectURL(url); // 释放掉blob对象
      }
    },

     
  },
  computed: {
	    ...mapGetters([
	    	'groupid'
	    ])
  },
  created(){
  	
  	console.log($(window).height()-200);
  	this.height=$(window).height()-400
  },
  mounted() {
  	this.pdata.sdate = this.$route.query.sdate;
  	this.pdata.edate = this.$route.query.edate;
  	this.pdata.cp_company_id = this.$route.params.id;
  	this.d_date = [this.pdata.sdate,this.pdata.edate];
    this.getList();
    this.getConfig();

    this.prWidth = document.getElementById("section").offsetWidth;
  }
};
</script>
<style scoped lang="scss">
span.gn{
	color: #20A0FF;
	cursor: pointer;
}
.dialog {
  width: 800px;
}
.size {
  width: 100px;
  text-align: right;
  position: absolute;
  top: 20px;
  left: -100px;
  padding-right: 14px;
  box-sizing: border-box;
  color: #999;
  font-size: 12px;
}
.bill{

	line-height: 48px;
	text-align: center;
	margin: 20px 0;
	overflow: hidden;
	border-top:1px solid #F2F6FC;
}
.bill .el-row{
	border-bottom:1px solid #F2F6FC;
	border-right:1px solid #F2F6FC;

	
}
.bill .el-row .el-col:first-child{
	
	border-right:1px solid #F2F6FC;
}
</style>

<style >

#ta,#ta .el-table__header-wrapper tbody td , #ta.el-table thead {
	color: #000000 ;
}
.el-table--striped .el-table__body tr td{
	background: #FFFFFF;
	
}

.el-table--striped .el-table__body tr td{
	background: #FFFFFF;
	
}
.demo-table .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    min-width: 200px;
    padding: 0 25px;
}
.demo-table .demo-table-expand label {

    color: #99a9bf;
}
.el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: top;
}
.el-upload-list__item {
  line-height: 0;
}
.selectRow {
  min-width:1200px;padding:15px;background: #fff;
}
.statusRow {
  background: #f2f6fc;
  padding: 15px;
  box-sizing: border-box;
  border-left: 4px solid #409eff;
  min-width: 600px;
}
.statusRow > .el-button {
  margin-right: 6px;
}
.gameIcon {
  width: 60px;
  height: 60px;
  border-radius: 6px;
}
.dropdown {
  min-width: 120px;
  width: 170px;
}
.dropdown-menu {
  width: 170px;
  margin: 0 auto;
  text-align: center;
}
.search,
.input {
  width: 220px;
}
.inline {
  display: inline-block;
  vertical-align: top;
}
.pageRow {
  min-width: 1200px;
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  left: 0;
  bottom: -20px;
  z-index: 1000;
}
@media only screen and (max-width: 767px) {
  .phoneHide {
    display: none;
  }
  .search {
    width: 60px;
  }
  .selectRow {
    min-width: 300px;
    padding: 5px;
  }
  .dropdown {
    width: 100%;
  }
  .dropdown-menu {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// statisticsDetail.vue?eacd9072